import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanConfigTypes } from '@api/hitoryCheck';

import { mapDropdownOptions } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_AWTG_RAN_CONFIG_TYPES } from '@constants/queryKeys';

interface UseQueryHistoryCheckAwtgRanConfigTypesParams {
	vendor?: string;
}

export const useQueryHistoryCheckAwtgRanConfigTypes = ({
	vendor,
}: UseQueryHistoryCheckAwtgRanConfigTypesParams) => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<TNameTitle[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_AWTG_RAN_CONFIG_TYPES, vendor],
		queryFn: getHistoryCheckAwtgRanConfigTypes,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: (options) => mapDropdownOptions({
			items: options,
			labelKey: 'title',
			valueKey: 'name',
		}),
		enabled: [vendor === EVendorsValues.oran],
		...refetchOptions,
	});

	return {
		configTypeOptions: data || [],
		isLoading: isLoading && isFetching,
	};
};
